module.exports = __webpack_public_path__ + "static/qr-google-play-d2625b9604194d50db0828513682edd3.svg";